/* eslint-disable react/prop-types */
import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link, WithMember } from "@quintype/components";
// import { parseUrl } from "query-string";
import { Logo } from "../../../molecules/publisher-logo";
import { SubscriptionHelper } from "../subscription-helpers";
import { BLOCKS, GIFTBLOCKS, TEXT } from "../constants";
import assetify from "@quintype/framework/assetify";
import merch from "../../../../../assets/images/nl-images/merch.png";
import gift from "../../../../../assets/images/nl-images/nl-sena-page.png";
// import Logo2 from "../../../../../assets/images/nl-images/logo-white.png";
import "./subscription-blocks.m.css";
// import { getAuthUrl } from "../../../helper/hooks";

export const SubscriptionBlocks = props => {
  return (
    <WithMember>
      {({ member }) => {
        return (
          <div styleName="wrapper" className="full-width">
            <div styleName={props.gift ? "top-gift-wrapper" : "top-wrapper"}>
              <Link href="/">
                <Logo />
              </Link>
              <hr
                style={{
                  marginTop: "-2px",
                  border: "0.5px solid var(--nl-gray4)"
                }}
              />

              {props.gift && <img src={assetify(gift)} styleName="left-img" />}
              {props.gift && <img src={assetify(gift)} styleName="right-img" />}
              {!props.gift && (
                <img src={assetify(merch)} styleName="left-img" />
              )}
              {!props.gift && (
                <img src={assetify(merch)} styleName="right-img" />
              )}

              <h2 styleName="title">
                {!props.gift ? TEXT.subscriptionTitle : TEXT.giftTitle}
              </h2>
              <small>
                {!props.gift
                  ? TEXT.subscriptionDescription
                  : TEXT.giftDescription}
              </small>
            </div>

            <div styleName="block-wrapper">
              {!props.gift
                ? BLOCKS.map((block, index) => {
                    return (
                      <Block
                        data={block}
                        key={index}
                        value={index}
                        member={member}
                        URL={props.URL}
                      />
                    );
                  })
                : GIFTBLOCKS.map((block, index) => {
                    return (
                      <Block
                        data={block}
                        key={index}
                        value={index}
                        gift={true}
                        member={member}
                        URL={URL}
                      />
                    );
                  })}
            </div>

            <SubscriptionHelper {...props} gift={props.gift} />
            <br />
          </div>
        );
      }}
    </WithMember>
  );
};

const Block = ({ data, value, gift, member, URL }) => {
  const isRecurring = useSelector(state =>
    get(state, ["fetchSubscription", "isRecurring"], null)
  );
  return (
    <div styleName={value !== 1 ? "block" : "block best-value"}>
      {value === 1 && <small>BEST VALUE</small>}
      <h3 styleName="block-title">{data.groupName}</h3>

      {data.originalPrice && (
        <span>
          <strike>{data.originalPrice}</strike>
        </span>
      )}
      <h2 styleName="price">{data.price}</h2>
      <p styleName="duration">{data.planName}</p>

      {gift ? (
        <Link
          href={
            member
              ? `/subscription/checkout?plan=${data.planId}&gift=true`
              : "https://auth.newslaundry.com/user-login?callback-url=https://www.newslaundry.com&redirect-url=https://www.newslaundry.com/gift"
          }
        >
          <button>Gift</button>
        </Link>
      ) : (
        <Link
          href={
            member && !isRecurring
              ? `/subscription/checkout?plan=${data.planId}`
              : !member
              ? "https://auth.newslaundry.com/user-login?callback-url=https://www.newslaundry.com&redirect-url=https://www.newslaundry.com/subscription"
              : null
          }
        >
          <button
            onClick={() =>
              isRecurring &&
              window.alert(
                "Oops!You already have a recurring subscription. Try sena, student or gift subscription."
              )
            }
          >
            Subscribe
          </button>
        </Link>
      )}

      <ul styleName="benefits">
        {data.benefits.map((benefit, index) => {
          return (
            <li key={index}>
              <i className="material-icons">check</i>
              {benefit}
            </li>
          );
        })}

        {data.plus && (
          <p>
            <span>PLUS</span>
          </p>
        )}

        {data.plus &&
          data.plus.map((benefit, index) => {
            return (
              <li key={index}>
                <i className="material-icons">check</i>
                {benefit}
              </li>
            );
          })}
      </ul>
    </div>
  );
};
